import clsx, { type ClassValue } from 'clsx';

/** Une clases condicionales manteniendo el orden de Tailwind. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
